import Swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import get from './get'


let options = {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 32,
  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
  }
}
if (get.ww() === 'pc') {
  options.slidesPerView = 3,
  options.spaceBetween = 20
}
const swiper = () => {
  const swipers = document.querySelectorAll('.swiper')
  Array.from(swipers, (e) => {
    const $swiper = e.firstElementChild
    new Swiper($swiper, options)
  })
}

export default swiper
